import { createModel } from '@rematch/core'
import { RootModel } from '@stores'

import { TPaymentReceiverInfoResponse } from '../../api/types/TPaymentReceiverInfoResponse'
import { TPurchaseReceiverInfoState } from '../types/TPurchaseReceiverInfoState'

export const p2pPurchase = createModel<RootModel>()({
  state: {} as TPurchaseReceiverInfoState,
  reducers: {
    set(state, payload: TPurchaseReceiverInfoState) {
      return { ...state, ...payload }
    },
  },
  effects: (dispatch) => ({
    initP2PReceiverInfo(payload: TPaymentReceiverInfoResponse) {
      dispatch.p2pPurchase.set({ ...payload })
    },
  }),
})
